import { ValidationRule } from 'src/api/validate/types';
import { EVENT_TYPES } from 'src/api/getEvents/types';
import type { ScheduleEventType } from 'src/api/getSchedules/types';

// Menu, menu set and timetable publishes validate a broader set covering bundles/option
// groups in addition to pricing basics (menu sets and timetables are collections of menus). Pricing publishes validate POS ID, tax rate,
// and default price; product publishes only check the first two (no price
// scheme is attached).
export const getValidationRules = (eventType: ScheduleEventType): ValidationRule[] => {
  switch (eventType) {
    case EVENT_TYPES.PUBLISH_MENU:
    case EVENT_TYPES.PUBLISH_MENU_SET:
    case EVENT_TYPES.PUBLISH_TIMETABLE:
      return [
        ValidationRule.ITEM_TAX_RATE,
        ValidationRule.ITEM_BUNDLE_MIN_ONE_OPTION_GROUP,
        ValidationRule.ITEM_OPTION_GROUP_MIN_ONE_OPTION,
        ValidationRule.ITEM_DEFAULT_PRICE,
        ValidationRule.ITEM_POS_ID,
      ];
    case EVENT_TYPES.PUBLISH_PRICING:
      return [ValidationRule.ITEM_POS_ID, ValidationRule.ITEM_TAX_RATE, ValidationRule.ITEM_DEFAULT_PRICE];
    default:
      return [ValidationRule.ITEM_POS_ID, ValidationRule.ITEM_TAX_RATE];
  }
};
